'use client';

import { RadioCard, RadioGroup, Stack } from '@pie/amber';
import { type PaymentMethodType } from '@/lib/api/billing';

export type StripeMethodSelectorProps = {
  value: PaymentMethodType;
  onValueChange: (value: PaymentMethodType) => void;
  disabled?: boolean;
};

export const StripeMethodSelector = ({
  value,
  onValueChange,
  disabled,
}: StripeMethodSelectorProps) => (
  <RadioGroup
    legend="Payment method type"
    name="stripePaymentMethodType"
    value={value}
    onValueChange={(next) => onValueChange(next as PaymentMethodType)}
    disabled={disabled}
  >
    <Stack direction={{ base: 'column', sm: 'row' }} gap="sm">
      {/* min-h matches the Zuora selector height */}
      <RadioCard value="ach" label="US bank account" className="flex-1 md:min-h-[102px]" />
      <RadioCard value="card" label="Card" className="flex-1" />
    </Stack>
  </RadioGroup>
);
